export default "__VITE_ASSET__BAgjqDGc__"